///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item = abcsetup.rx_item || {};
abcsetup.rx_item.create = abcsetup.rx_item.create || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.create.removeButtons = [];
abcsetup.rx_item.create.one_ws_item = [];
abcsetup.rx_item.create.removeButtonsFieldTeam = [];




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item.create = {
    init: function() {
        abcsetup.setTitle('Add Rx Item');
        abcsetup.rx_item.create.removeButtons = ['maintenance_approve_screenshot'];
        abcsetup.rx_item.create.removeButtonsFieldTeam = ['hda_form', 'case_label', 'flat_product_bar_code_image'];

        // Init any field restrictions/values
        this._initFields();

        // Init the SAP Divisions
        this._initGTIN();

        // Init the GTIN Grid
        this._initSAPDiv();

        // Init the attachment buttons
        this._initAttachments();

        // Init 1ws
        this._initOneWs();
        // Delete attachment button clicked
        $(document).on('click', '.delete-attachment', function(event) {
            event.preventDefault();
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Attachment', 'Are you sure you want to delete this attachment?', function (resp) {
                if (resp) {
                    _this.parent().fadeOut('slow', function() {
                        $(this).remove();

                        // Auto save the item form
                        //abcsetup.rx_item.create._autoSave();
                        $('button#'+_this.attr("id")).addClass('required btn-danger').show();
                    });
                }
            });
        });

        $(document).on('change', '#product_regulated_cfr', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_cfr').val('');
                $('#un_id_cfr').val('');
                $('#hazard_class_cfr').val('');
                $('#pack_group_cfr').val('');
                $('#shipping_name_1_cfr').val('');
                $('#label_code_cfr').val('');
                $('#qty_limit_par_cfr').val('');
                $('#qty_limit_cao_cfr').val('');
                $('#vessel_stowage_location_cfr').val('');
                $('#vessel_stowage_other_cfr').val('');
            }
        });

        $(document).on('change', '#product_regulated_iata', function() {
            if ($(this).val() == 'N' || $(this).val() == '') {
                $('#hazmat_id_iata').val('');
                $('#un_id_iata').val('');
                $('#shipping_name_iata').val('');
                $('#descr_iata').val('');
                $('#pack_group_iata').val('');
            }
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all front store form related JS is handled in the global /forms/_rx_item_item.js form namespace
        abcsetup.rx_item.form.init();
    },

    /**
     * Init any field restrictions/values
     */
    _initFields: function() {
        require('./_common_rules');
    },

    /***
    * Events for One world sync functionality
    */
   _initOneWs: function () {

        // Show the 1ws modal
        $('#onews-btn').click(function() {
            console.log('abcsetup.orgOneWs',abcsetup.orgOneWs.one_ws_cis.length);

            var registered = false;
            if (abcsetup.orgOneWs.one_ws_cis.length > 0) {
                $(abcsetup.orgOneWs.one_ws_cis).each(function() {
                    if (this.state == 'active') {
                        registered = true;
                        return false;
                    }
                });
            }

            if (registered) {
                abcsetup.rx_item.create.oneWs();
            } else  {
                abcsetup.alerts.confirm('1WorldSync Registration', 'Sorry! You haven’t registered with 1WorldSync yet. To register, please go to <a href="https://www.abcsetup.com/1ws_cis/index" target="_blank">1WorldSync Registration</a> and enter your GLN to get started. Please contact support@cencorasupplierportal.com for any questions.');
            }
        });

        $("#item_gtin").change(function(e){
            var item_gtin = $(this).val();
            if (item_gtin.length == 14) {
                axios.get('/api/one_ws/search?column=gtin&value=' + item_gtin).then(response => {
                    if (response.data.length) {
                        $('#onews-btn').trigger('click');
                    }
                });
            }
         });

        // OneWs modal hidden
        $('#onews-modal').on('hidden.bs.modal', function (e) {
            $('#onews-modal').find('#results').data('searchString', '');
        });

        // Item modal field(s) changed
        $('#onews-modal input').bind('change keyup', function() {
            clearTimeout(abcsetup.rx_item.create.itemTimeout);

            abcsetup.rx_item.create.itemTimeout = setTimeout(function() {
                abcsetup.rx_item.create.findOneWsItem();
            }, 500);
        });

        // Populate fields
        $(document).on('click', '.btn.btn-populate', function (e) {
            abcsetup.rx_item.create.populateForm($(this).data('id'));
        });
   },

    /**
     *
     */
    _initAttachments: function() {
        $(abcsetup.rx_item.create.removeButtons).each(function() {
            $('button#' + this).remove();
            $('input[data-idx="' + this + '"]').remove();
        });

        if (abcsetup.userRole.class == 'field_team') {
            $(abcsetup.rx_item.create.removeButtonsFieldTeam).each(function() {
                $('button#' + this).remove();
                $('input[data-idx="' + this + '"]').remove();
            });
        }

        // Manually apply showIf rules to buttons and their input fields
        $('button#sds_waiver, input[data-idx="sds_waiver"]').attr('showIf', 'sds_waiver=N');
        abcsetup.fieldLib.bindElement($('button#sds_waiver, input[data-idx="sds_waiver"]'), 'showIf');

        $('button#msds_sheet, input[data-idx="msds_sheet"]').attr('showIf', 'sds_waiver=Y');
        abcsetup.fieldLib.bindElement($('button#msds_sheet, input[data-idx="msds_sheet"]'), 'showIf');

        $('button#fda_waiver, input[data-idx="fda_waiver"]').attr('showIf', 'fda_exempt=Y');
        abcsetup.fieldLib.bindElement($('button#fda_waiver, input[data-idx="fda_waiver"]'), 'showIf');

        $('button#sap_pricing_letter, input[data-idx="sap_pricing_letter"]').attr('showIf', '(_USER_CLASS_=bluepoint_cm)|(_INIT_CLASS_=bluepoint_cm)');
        abcsetup.fieldLib.bindElement($('button#sap_pricing_letter, input[data-idx="sap_pricing_letter"]'), 'showIf');

        $('button#ahp_pricing_letter, input[data-idx="ahp_pricing_letter"]').attr('showIf', '((_USER_CLASS_=bluepoint_cm|_INIT_CLASS_=bluepoint_cm)&bluepoint_notify=AHP)');
        abcsetup.fieldLib.bindElement($('button#ahp_pricing_letter, input[data-idx="ahp_pricing_letter"]'), 'showIf');

        $('button#mwi_pricing_letter, input[data-idx="mwi_pricing_letter"]').attr('showIf', '(_USER_CLASS_=bluepoint_cm|_INIT_CLASS_=bluepoint_cm)&bluepoint_notify=MWI');
        abcsetup.fieldLib.bindElement($('button#mwi_pricing_letter, input[data-idx="mwi_pricing_letter"]'), 'showIf');


        $('button#pr_registration_doc, input[data-idx="pr_registration_doc"]').attr('showIf', 'pr_registration=Y');
        abcsetup.fieldLib.bindElement($('button#pr_registration_doc, input[data-idx="pr_registration_doc"]'), 'showIf');

        $('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]').attr('showIf', 'item_setup_reason=Short Dated');
        abcsetup.fieldLib.bindElement($('button#short_dated_offer_letter, input[data-idx="short_dated_offer_letter"]'), 'showIf');
    },

    /**
     * Init the GTIN Grid
     */
    _initGTIN: function() {
        require('./_gtin_grid');
    },

    /**
     * Init the SAP divisions
     */
    _initSAPDiv: function() {
        require('./_sap_divisions');
    },


    /**
     * Auto save the item form
     */
    _autoSave: function() {
        /*$('form.rx-item').append('<input type="hidden" class="tmp-action" name="form_action" value="update">');
        axios.post('/rx_item/' + abcsetup.item.id + '?auto=t', $('form.rx-item').serialize()).then(response => {
            $('form.rx-item').find('.tmp-action').remove();
        });*/
    },

    /**
     * Show the add item modal
     */
    oneWs: function() {
        $('#onews-modal .modal-title').html('Search 1WorldSync Items');
        $('#onews-modal').find('#results').html('');

        $('#onews-modal').modal('show');
    },

    /**
     *
     */
    findOneWsItem: function() {
        var gtin = $('#onews-modal').find('#gtin').val();
        var limit_vendor = '';

        abcsetup.rx_item.create.one_ws_item = [];

        // No search params are specified
        if (gtin == '') {
            $('#onews-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = gtin;
        if ($('#onews-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#onews-modal').find('#results').data('searchString', searchString);

        // We're not re-linking an item, limit the items to the current vendor
        // if (abcsetup.rx_item.create.rx_item_id == 0) {
        limit_vendor = abcsetup.userOrg.id;
        //}

        // Block the UI with a spinner
        abcsetup.blockUI(true);

        console.log('findOneWsItem',gtin);
        axios.get('/api/one_ws/search?column=gtin&value=' + gtin + '&limit_vendor=' + limit_vendor).then(response => {
            abcsetup.unblockUI();

            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>Description</th>\
                                        <th>Category Name</th>\
                                        <th>Unit of Measure</th>\
                                        <th>Shipping Method</th>\
                                    </tr>\
                                </thead>';

            var supplier_descr = '';
            var category = '';
            var uom = '';
            var shipping_method = '';
            var row_class = '';

            $(response.data).each(function() {
                var gtinData = this;
                if (gtinData.gtin == gtin) {
                    $(gtinData.one_ws_item_attr).each(function() {
                        if (this.col == 'supplier_descr') {
                            supplier_descr = this.val;
                        }
                        if (this.col == 'category') {
                            category = this.comment;
                        }
                        if (this.col == 'uom') {
                            uom = this.val;
                        }
                        if (this.col == 'shipping_method' && (this.val != '' && this.val != null)) {
                            shipping_method = this.val;
                        }
                    });
                }

                if (shipping_method == '' || shipping_method == null) {
                    $(gtinData.one_ws_item_attr).each(function() {
                        if (this.col == 'shipping_method' && (this.val != '' && this.val != null)) {
                            shipping_method = this.val;
                        }
                    });
                }
            });

            abcsetup.rx_item.create.one_ws_item[gtin] = response.data;

            html = html + '<tr class="' + row_class + '">\
                                <td>' + ((supplier_descr != null) ? supplier_descr : '') + '</td>\
                                <td>' + ((category != null) ? category : '') + '</td>\
                                <td>' + ((uom != null) ? uom : '') + '</td>\
                                <td>' + ((shipping_method != null) ? shipping_method : '') + '</td>\
                                <td nowrap><button type="button" class="btn btn-primary btn-populate btn-sm" data-id="' + gtin + '">Populate Form</button></td>\
                            </tr>';

            if (!response.data.length) {
                html = html + '<tr><td colspan="12" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#onews-modal').find('#results').html(html);

            // Apply the highlighting
            var body = $('#onews-modal').find('#results tbody');
            //body.unhighlight();

            //body.highlight([identifier, mfr_prod_code, mat_descr, category]);
        });
    },

    /**
    * Populate form with 1worldsync item
    */
    populateForm: function(id) {
        //console.log(JSON.stringify(abcsetup.rx_item.create.one_ws_item[id],{},4));
        abcsetup.rx_item.create.populateItem(id);
        // Hide and reset the modal
        $('#onews-modal input, #onews-modal select').val('');
        $('#onews-modal').modal('hide');

    },

    /**
     * Populate 1worldsync item into the form
     */
    populateItem: function(id) {

        $(abcsetup.rx_item.create.one_ws_item[id]).each(function() {
            var gtinData = this;
            $(gtinData.one_ws_item_attr).each(function() {
                // check if this is a dedicated fs or rx 1WS input field
                if (this.col.match(/^fs\./)) {
                    // this column is only for front_store_items - ignore
                    return;
                }
                else if (this.col.match(/^rx\./)) {
                    this.col = this.col.replace(/^rx\./,'');
                }
                // populate the form with the 1WS input fields
                if (this.col != 'brand' && this.col != 'category' && this.col != 'country_origin' && this.col != 'rems_level') {
                    // The 1WS item data is stored in 1ws_item_attr.col using front_store_item col names
                    // as this is where the development started (and we don't know at the time of
                    // ingesting 1WS data whether this will used to create a front_store or rx item),
                    // so we map some front_store col names to rx col names here:
                    // FIXME: this bites us lower down with the population of the GTIN grid where we work
                    // with columns that ARE called pack_quantity and inner
                    this.col = this.col.replace("_pack_quantity","_pieces"); // e.g. case_pack_quantity -> case_pieces
                    this.col = this.col.replace("inner_","pack_"); // e.g. inner_height -> pack_height
                    //console.log(this.col+"->"+col);
                    if (this.val != '' && this.val != null) {
                        $("#"+this.col).val(this.val).trigger('change');
                    }
                }
                else if (this.col == 'country_origin' || this.col == 'rems_level') {
                    var select_right = $("#"+this.col);
                    var this_shuttlebox = select_right.closest("div.shuttlebox");
                    var select_left = this_shuttlebox.find("select.shuttlebox-left");
                    var value = this.val;
                    if (value) {
                        var values = value.split(",");
                        $.each( values, function( key, value ) {
                            select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                            select_left.find("option[value="+value+"]").remove();
                        });
                    }
                }
                // FIXME: this logic below seems flawed as we will only get here for brand and category - instead
                // replace it with the always-show logic for field comments just below
                // else {
                //     $(".1ws_"+this.col).remove();
                //     var value = this.val != null && this.val != '' ? this.val : this.comment;
                //     $("#"+this.col).val(value).after('<span class="small inForm text-danger errorMsg 1ws_'+this.col+'">Unable to map this 1WorldSync attribute value: '+value+'</span>');;
                // }
                // GE: always display the comment if it is provided
                if (this.comment) {
                    // NOTE: the same 1WS field comment may be provided at every UOM, so we clear out any previously-added comments at other UOMs
                    // to make sure we don't add it multiple times
                    $(".1ws_"+this.col).remove();
                    $("#"+this.col).after('<span class="small inForm text-info 1ws_'+this.col+'">'+this.comment+'</span>');
                }
            });
        });



        // Populate gtin grid
        var build_gtin_data = {}
        $(abcsetup.rx_item.create.one_ws_item[id]).each(function() {
            var gtinData = this;
            $(gtinData.one_ws_item_attr).each(function() {
                //console.log("gtinData.one_ws_item_attr"+JSON.stringify(gtinData.one_ws_item_attr,{},4))
                if (this.col.indexOf('_pieces') > -1  || this.col.indexOf('_gtin') > -1 || this.col.indexOf('_saleable_unit') > -1 || this.col.indexOf('_rfid_tag') > -1) {
                    var temp_gtin_data = {}
                    // NOTE: _pack_quantity was replaced with _pieces above
                    // We replace pack with inner as the rx_item_gtin table uses "inner" as the PK designation
                    var level = this.col.replace('_pieces','').replace('_gtin','').replace('_saleable_unit','').replace('_rfid_tag','').replace('pack','inner');
                    if (['item','case','inner','pallet'].includes(level)) {
                        if (typeof build_gtin_data[level] == 'undefined') {
                            temp_gtin_data[level] = {
                                'qty' :'',
                                'gtin_14' : '',
                                'saleable_unit' : '',
                                'rfid_tag' : ''
                            }
                            build_gtin_data = {...build_gtin_data, ...temp_gtin_data }
                        }

                        if (this.col.indexOf('_pieces') > -1 ) {
                            build_gtin_data[level].qty = this.val;
                        } else if (this.col.indexOf('_gtin') > -1 ) {
                            build_gtin_data[level].gtin_14 = this.val;
                        } else if (this.col.indexOf('_saleable_unit') > -1) {
                            build_gtin_data[level].saleable_unit = this.val;
                        } else if (this.col.indexOf('_rfid_tag') > -1) {
                            build_gtin_data[level].rfid_tag = this.val;
                        }
                    }
                }
            });
        });


        $('.enable_gtin_level').each(function () {
            var level = $(this).val();
            if (build_gtin_data[level]) {
                $(this).prop("checked", true);
                $(this).trigger("change");
                // Fill Quantity field
                if (build_gtin_data[level].qty) {
                    $("input[name='gtin_items["+level+"][qty]']").val(build_gtin_data[level].qty);
                }
                //Fill HIBCC
                $("input[name='gtin_items["+level+"][gtin_14]']").val(build_gtin_data[level].gtin_14);
                $("select[name='gtin_items["+level+"][saleable_unit]']").val(build_gtin_data[level].saleable_unit);
                $("select[name='gtin_items["+level+"][rfid_tag]']").val(build_gtin_data[level].rfid_tag);
            }
        });
        $('form.rx-item').find('#onews_gtin').val($('#onews-modal').find('#gtin').val());

        $("button#hda_form").removeClass("required btn-danger")
        if (!$("button#hda_form").hasClass('btn-optional')){
            $("button#hda_form").addClass('btn-optional');
        }
        $("input[data-idx='hda_form']").attr('required',false);
    },
}
